var PascalCaseConverter = /** @class */ (function () {
    function PascalCaseConverter() {
    }
    PascalCaseConverter.toKebabCase = function (string) {
        return string.replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
            return '-' + y.toLowerCase();
        }).replace(/^-/, '');
    };
    return PascalCaseConverter;
}());
export { PascalCaseConverter };
